import { SiteThemeCookie } from 'auth-types';
import CookieService from './general/cookie-service';

const SiteThemCacheService = {
  getThemeCookie(): SiteThemeCookie | undefined {
    return CookieService.get('U_THEME') as unknown as SiteThemeCookie;
  },
  setThemeCookie(data: SiteThemeCookie): void {
    CookieService.set('U_THEME', data);
    return;
  },
  resetThemeCookie(): void {
    CookieService.delete('U_THEME');
    return;
  },
};

export default SiteThemCacheService;
